<div
  appSelectableList
  #appSelectableList="appSelectableList"
  [deselectOnReclick]="false"
  [appSelectableListReset]="resetSelected"
  [appSelectableListItems]="listItems()"
  [appSelectableListChain]="selectionChain()"
  (openSelected)="clickEvent.emit($event.item.data)"
  class="bg-background-highlight"
>
  @for (item of events(); track item.id; let index = $index) {
    <app-event
      [item]="item"
      [position]="index"
      [withTags]="withTags()"
      [withKnots]="withKnots()"
      [withBar]="true"
      [short]="false"
      (appDblClick)="doubleClickEvent.emit(item)"
      [appSelectable]="item"
      [appSelectablePosition]="index"
      [appSelectableIdentifier]="item.id"
      [appSelectableListRef]="appSelectableList"
    />
  }
</div>
